import { useQuery as useRelatedSearchesQuery } from "@faire/web-api--source/endpoints/www/api/seo/brand-terms/brandToken/get-hooks";
import { useStrictLocalization } from "@faire/web/common/localization";

export const useLoggedOutBrandTopSearchPlaceholder = (
  brandToken: string | undefined
) => {
  const { strictLocalize } = useStrictLocalization();
  const fallbackPlaceholder = strictLocalize({
    id: "KChW/3",
    defaultMessage: "Search wholesale products or brands",
    description: {
      text: "Text for search box.",
    },
  });

  const { data: relatedSearchesData, isPending } = useRelatedSearchesQuery(
    brandToken ?? "",
    {
      enabled: !!brandToken,
    }
  );

  const relatedSearches = relatedSearchesData?.terms;

  const firstRelatedSearch = relatedSearches?.[0];

  if (isPending) {
    return undefined;
  }

  return firstRelatedSearch
    ? strictLocalize(
        {
          id: "Q3+gog",
          defaultMessage: "Search for “{searchProductName}”",
          description: {
            text: "Suggested search term for the search bar",
          },
        },
        {
          searchProductName: firstRelatedSearch ?? "",
        }
      )
    : fallbackPlaceholder;
};
